import * as React from 'react';

import Loader from 'bundles/degree-home/components/Loader';
import SummaryCourseItem from 'bundles/degree-home/components/SummaryCourseItem';

import _t from 'i18n!nls/degree-home';

import { SummaryCard } from './SummaryCard';
import type {
  GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_notStarted_courseProgressState_DegreeLearnerCourseStatesV1_notStartedMember as CourseProgressState,
  GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_notStarted as NotStartedCourse,
} from './v2/UpcomingCourses/__generated__/getUpcomingCourseStatesQuery';

type Props = {
  loading: boolean;
  notStartedCourses?: Array<NotStartedCourse>;
};

export const NotStartedCourses: React.VFC<Props> = ({ loading, notStartedCourses }) => (
  <SummaryCard title={_t('Upcoming')}>
    {loading && <Loader />}
    {!loading &&
      notStartedCourses?.map((notStartedCourse: NotStartedCourse) => {
        const progressState = notStartedCourse.courseProgressState as unknown as CourseProgressState;
        const isCourseEnrollable =
          progressState.notStarted.hasEnrollableSession && !progressState.notStarted.activeSessionId;

        return (
          <SummaryCourseItem
            key={notStartedCourse.id}
            courseId={notStartedCourse.id}
            courseName={notStartedCourse.name}
            courseSlug={notStartedCourse.slug}
            statusText={_t('Not started')}
            isCourseEnrollable={isCourseEnrollable}
          />
        );
      })}
  </SummaryCard>
);

export default NotStartedCourses;
